<template>
  <section class="content">
    <loader v-show="loading"></loader>
    <vuetable
      v-show="!loading"
      v-on:table-delete-request="deleteEntity"
      v-on:table-edit-request="handleEdit"
      :showEdit="true"
      :showDelete="true"
      :tableData="tableData"
      :tableTitle="'Parties'"
      :fields="fields"
      v-on:pages-remaining="loadMore"
      :maxItems="maxValue"
    ></vuetable>
  </section>
</template>
<script>
  import vuetable from '../../../helpers/VueTable.vue'
  import Loader from '../../../helpers/Loader.vue'
  import AdminSearchResults from '../../mixins/AdminSearchResultsMixin.js'
  import API from '../../../../api/endpoints'
  import event from '../../../../event'
  export default {
    name: 'PartySearchResults',
    components: {
      vuetable: vuetable,
      Loader
    },
    mixins: [ AdminSearchResults ],
    data () {
      return {
        fields: [
          { header: 'Name', prop: 'name', hideByDefault: false },
          { header: 'Code', prop: 'code', hideByDefault: false },
          { header: 'Address', prop: item => this.displayLocation(item.address), hideByDefault: false },
          { header: 'Category', prop: 'category', hideByDefault: true },
          { header: 'Party Group', prop: item => item.partyGroup !== null ? item.partyGroup.name : '', hideByDefault: true }
        ],
        loading: false,
        tableData: [],
        entityName: 'party',
        editEntityScreen: 'Admin - Edit/View Party',
        lazy: '1'
      }
    },
    computed: {
      shouldSearchWithLocationParams () {
        return this.queryObj.hasOwnProperty('country') && this.queryObj.country !== null && this.queryObj.country !== ''
      },
      queryObjStripped () {
        let o = {}
        for (let prop in this.queryObj) {
          if (this.queryObj[prop] !== '' && this.queryObj[prop] !== null) {
            o[prop] = this.queryObj[prop]
          }
        }
        return o
      }
    },
    methods: {
      displayLocation (location) {
        let str = ''
        if (location) {
          if (location.address) {
            str += location.address
          }
          if (location.subdivision) {
            str += `, ${location.subdivision}`
          }
          if (typeof location.country === 'object' && location.country !== null && location.country.hasOwnProperty('code')) {
            str += `, ${location.country.code}`
          }
        }
        return str
      },
      loadMore () {
        if (!this.isFetching && !this.dataFullyLoaded) {
          this.isFetching = true
          this.page++
          const data = this.getHttpPromise({ 'X-Limit': '500', 'X-Page-Number': String(this.page) })
          data.then(({data}) => {
            this.tableData.push(...data)
          }).catch(err => {
            console.log(err)
          }).then(() => {
            this.isFetching = false
          })
        }
      },
      getResults () {
        if (!this.entityName) {
          window.console.warn(`If you are seeing this message, component '${this.$options.name}' has not overwritten the 'entityName' property`)
        } else {
          this.page = 1
          const params = this.decrypt(this.$route.query)
          this.loading = true
          this.isFetching = true
          let data = this.getHttpPromise({ 'X-Limit': '500', 'X-Page-Number': '1' })
          data.then(({data}) => {
            this.tableData = data
          }).catch(err => {
            this.notifyResults(false)
            console.log(err)
          }).then(() => {
            this.loading = false
            this.isFetching = false
            this.fetchMaxValue()
          })
        }
      },
      fetchMaxValue () {
        const data = this.getHttpPromise({ 'X-Count-Fetch': 'true' })
        data.then(({data}) => {
          this.notifyResults(true, data.value)
          this.maxValue = data.value
        })
        .catch(err => console.log(err))
      },
      getHttpPromise (opts) {
        if (!this.isFullSearch) {
          return this.quickSearch(opts)
        } else {
          if (this.shouldSearchWithLocationParams) {
            return this.findResultsUsingLocation(opts)
          } else {
            return this.fullSearch(opts)
          }
        }
      },
      findResultsUsingLocation (opts) {
        return this.$http.get(API.FIND_PARTIES_USING_LOCATION_FILTER, {
          headers: {
            'X-Lazy-Fetch': this.lazy || '1',
            ...opts
          },
          params: this.queryObjStripped
        })
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/modules/admin/components/Party/PartySearchResults.vue